import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import DropdownInfo from '@/app/editor/sidebar/elementsInfo/dropdown';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'name',
    targetSelector: '.gf_dropdown',
    property: 'name',
  },
  {
    type: 'html:select',
    name: 'options',
    targetSelector: '.gf_dropdown',
    property: '',
  },
  {
    type: 'html:attr',
    name: 'required',
    targetSelector: '.gf_dropdown',
    property: 'required',
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_dropdown',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_dropdown',
    property: 'height',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.gf_dropdown',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.gf_dropdown',
    property: 'font-family',
    require: true,
  },
  {
    type: 'css',
    name: 'text-color',
    targetSelector: '.gf_dropdown',
    property: 'color',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpDropdown extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : DropdownInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || DropdownInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || DropdownInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + DropdownInfo.class;
  }
}
